import React, { useMemo, useState } from 'react';
import { highlight } from './highlight.js';

// bar={false} is Storybook's <Source>: no header, Copy in the bottom corner.
export function Code({ code = '', language = 'html', copy = true, bar = true, className = '' }) {
  const [copied, setCopied] = useState(false);
  const html = useMemo(() => highlight(String(code), language), [code, language]);
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(String(code));
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch {
      // Clipboard blocked (insecure origin or permissions): nothing to do.
    }
  };
  return (
    <div className={`edl-code${bar ? '' : ' edl-code--bare'} ${className}`}>
      {bar && (
        <div className="edl-code__bar">
          <span className="edl-code__lang">{language && language !== 'text' ? language : ''}</span>
          {copy && (
            <button type="button" className="edl-link-button" onClick={onCopy}>
              {copied ? 'Copied' : 'Copy'}
            </button>
          )}
        </div>
      )}
      <pre className="edl-code__pre">
        <code dangerouslySetInnerHTML={{ __html: html }} />
      </pre>
      {!bar && copy && (
        <button type="button" className="edl-link-button edl-code__copy" onClick={onCopy}>
          {copied ? 'Copied' : 'Copy'}
        </button>
      )}
    </div>
  );
}
